import type { BackgroundMotionControl } from "./use-background-motion";

export function BackgroundMotionSettings({
  motion,
}: {
  motion: BackgroundMotionControl;
}) {
  const { status } = motion;
  if (status === "unsupported") return null;
  const enabled = status === "active" || status === "waiting";
  return (
    <section className="account-help" aria-label="Движение фона">
      <button
        type="button"
        disabled={status === "requesting" || status === "reduced-motion"}
        aria-pressed={enabled}
        onClick={enabled ? motion.disable : motion.enable}
      >
        {enabled
          ? "Выключить наклон фона"
          : status === "requesting"
            ? "Ожидаем разрешение…"
            : "Включить наклон фона"}
      </button>
      {status === "denied" && (
        <p role="status">
          Нет разрешения на датчик наклона.
        </p>
      )}
      {status === "unavailable" && (
        <p role="status">
          Датчик наклона недоступен.
        </p>
      )}
      {status === "reduced-motion" && (
        <p>Наклон отключён: в настройках устройства уменьшено движение.</p>
      )}
    </section>
  );
}
